import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { FulfillmentGroupStatus } from "@redotech/redo-fulfillment-group-common/fulfillment-group-status";
import { FulfillmentHold } from "@redotech/redo-fulfillment-group-common/fulfillment-hold";
import { ShopifyFulfillmentHoldDisplayNames } from "@redotech/redo-fulfillment-group-common/shopify-fulfillment-schemas";
import { Tooltip } from "@redotech/redo-web/arbiter-components/tooltip/tooltip";
import { Flex } from "@redotech/redo-web/flex";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { Text } from "@redotech/redo-web/text";
import { FulfillmentGroupStatusBadge } from "../../common/status-badge";

const catalogEntry = fgColumnEntries.status;

function HoldReasonTooltipContent({ holds }: { holds: FulfillmentHold[] }) {
  return (
    <Flex flexDirection="column" gap="xs">
      {holds.map((hold, i) => (
        <Flex flexDirection="column" gap="none" key={hold.holdHandle || i}>
          <Text fontSize="xxs" fontWeight="semibold">
            {ShopifyFulfillmentHoldDisplayNames[hold.reason]}
          </Text>
          {hold.reasonNotes && <Text fontSize="xxs">{hold.reasonNotes}</Text>}
        </Flex>
      ))}
    </Flex>
  );
}

export const StatusColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => {
    const holds = row.holds?.length ? row.holds : undefined;
    const isOnHold = row.status === FulfillmentGroupStatus.OnHold && holds;

    const badge = (
      <FulfillmentGroupStatusBadge fulfillmentGroupStatus={row.status} />
    );

    return (
      <Flex pl="lg">
        {isOnHold ? (
          <Tooltip leftAlign title={<HoldReasonTooltipContent holds={holds} />}>
            <div>{badge}</div>
          </Tooltip>
        ) : (
          badge
        )}
      </Flex>
    );
  },
  width: catalogEntry.defaultWidth,
};
